import { SiteType } from '@/gql/graphql';

declare global {
  interface Window {
    ctv: any;
  }
}

export const ResearchSites = {
  'Academic Medical Center or Clinical Trials Unit': SiteType.Amc,
  'Hospital or Health System': SiteType.Hospital,
  'Private Practice or Research Center': SiteType.PrivatePractice,
  'Site Network or Site Management Organization (SMO)': SiteType.Smo,
};

//these fiends are needed for UI rendering only and are not sent to the server
export interface UIOnlyFields {
  asCRO: boolean | undefined;
  agreedToTOS: boolean | undefined;
  addressAutocompleteLabel: string;
  addressAutocompleteKey: string;
}
